<div class=timer> <div class=timer__text> <span>{{ text }}</span> </div> <div class=timer__time> <span>{{ timerText }}</span> </div> </div> 